import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-53217ee6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrap" }
const _hoisted_2 = { class: "debug" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "#/" }, "トップページに戻る", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "URL", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "ユーザー情報（currentUser）", -1))
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" tourOptions")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("div", null, _toDisplayString(_ctx.href), 1),
      _hoisted_5,
      _createElementVNode("ul", null, [
        _createElementVNode("li", null, "objectId: " + _toDisplayString(_ctx.currentUser.objectId), 1),
        _createElementVNode("li", null, "memberNumber: " + _toDisplayString(_ctx.currentUser.memberNumber), 1),
        _createElementVNode("li", null, " hasUsedDrinkCoupon: " + _toDisplayString(_ctx.currentUser.hasUsedDrinkCoupon) + "　//ドリンククーポンの使用有無 ", 1),
        _createElementVNode("li", null, " hasUsedGoodsCoupon: " + _toDisplayString(_ctx.currentUser.hasUsedGoodsCoupon) + "　//グッズクーポンの使用有無 ", 1),
        _createElementVNode("li", null, "hasUsedCoupon: " + _toDisplayString(_ctx.currentUser.hasUsedCoupon), 1),
        _createElementVNode("li", null, " isPremiumMember: " + _toDisplayString(_ctx.currentUser.isPremiumMember) + "　//有料会員の有無 ", 1),
        _createElementVNode("li", null, "selectedTourIds: " + _toDisplayString(_ctx.currentUser.selectedTourIds), 1),
        _createElementVNode("li", null, [
          _hoisted_6,
          _createElementVNode("button", {
            style: _normalizeStyle({ transform: _ctx.showTourOptions ? 'rotate(45deg)' : '' }),
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleShowOptions && _ctx.handleShowOptions(...args)))
          }, null, 4),
          (_ctx.showTourOptions)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.currentUser.tourOptions, (item) => {
                return (_openBlock(), _createElementBlock("div", null, [
                  _createElementVNode("p", null, _toDisplayString(item), 1)
                ]))
              }), 256))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("li", null, "todayTourId: " + _toDisplayString(_ctx.currentUser.todayTourId), 1),
        _createElementVNode("li", null, " premiumMemberStartedAt: " + _toDisplayString(_ctx.currentUser.premiumMemberStartedAt) + "　//有料会員の登録日（タイムスタンプ） ", 1)
      ])
    ]),
    _createElementVNode("pre", null, _toDisplayString(JSON.stringify(_ctx.currentUser, null, 2)), 1)
  ]))
}